<ng-container *uiModalDescription>
  <div class="description-row" *ngIf="!loading">
    <ui-assignee-avatar-group class="owners" [uiMax]="2" uiSize="sm">
      <ui-assignee-avatar *ngFor="let assigneeId of metric.ownerIds" [fromAssigneeId]="assigneeId" />
    </ui-assignee-avatar-group>
    <div class="kr-description">{{ "created_on" | localize }}:&nbsp;{{ checkin?.createdAt | date : "MMMM dd, YYYY, HH:mm" }}</div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <update-metric-note-skeleton />
</ng-template>

<ui-loading-indicator [uiSpinning]="loading" [uiIndicator]="loadingTemplate">
  <div class="form">
    <form [formGroup]="updateMetricNoteForm">
      <div class="form-row">
        <rich-text-editor-with-mentions
          [removeAllMentionsAriaLabel]="removeAllMentionsAriaLabel"
          formControlName="note"
          data-test-id="update-comment-input-field"
          a11yLabelledby="update-kr-note-rte-label"></rich-text-editor-with-mentions>
      </div>
    </form>
  </div>

  <div class="buttons">
    <gh-indicator *ngIf="indicators.saving" [ghValue]="indicators.saving" [ghMessage]="'saving' | localize"></gh-indicator>
  </div>
</ui-loading-indicator>
